import async from 'components/template/Async';

export const ConfirmItem = async(() => import('pages/marketplace/ConfirmItem'));
